import React from 'react';
import {
  addPathToList, Android,
  Enter_manually_scan_barcode, getSubCategoryId, Select_a_bill, where_customer_enter,
} from '../utils/DictionaryManagementUtils';
import FullPagePanel from '../components/PanelsComponents/General/FullPagePanel';

//= ========================================================================
const Panel_D02_PayBillsEnterCode = ({
  globJSON,
  selectedScreen,
  onConfigChanged,
  onStepPressed,
  simPlatform,
  language,
}) => {
  const myScreen = globJSON.screens[selectedScreen];
  const subCategoryId = getSubCategoryId(myScreen);
  const subCategoryIdDefault = getSubCategoryId({ sub_category: myScreen.sub_category, duplication_number: 0 });
  const service = globJSON.configurations.services[subCategoryId];
  const { select_bill } = service;
  const editTextList = [
    'type_the_barcode_title',
    'scan_bill_barcode',
    'invalid_qr',
    'try_again',
  ].filter((textElement) => (textElement === 'type_the_barcode_title' ? true : simPlatform === Android && select_bill.enable_customer_to_scan_barcode));

  return (
    <FullPagePanel
      globJSON={globJSON}
      onConfigChanged={onConfigChanged}
      selectedScreen={selectedScreen}
      onStepPressed={onStepPressed}
      panelHeadline={Select_a_bill}
      panelSubHeadline={Enter_manually_scan_barcode}
      editTextList={addPathToList(editTextList, `configurations/services/${subCategoryId}/select_bill/`)}
      editTextListDefault={addPathToList(editTextList, `configurations/services/${subCategoryIdDefault}/select_bill/`)}
      tooltipsTitles={service.screens_ordering}
      paragraph={where_customer_enter}
      language={language}
    />
  );
};

export default Panel_D02_PayBillsEnterCode;
